import React from 'react';
import Modal from 'features/app/components/Modal';
import { FailedAction } from '../FailedAction';

type FailedActionModalProps = {
  closeButton?: boolean;
  onClose: () => void;
  error?: string;
  open: boolean;
  dialogContentClass?: string;
};

export const FailedActionModal: React.FC<FailedActionModalProps> = ({ open, onClose, error, dialogContentClass }) => {
  return (
    <Modal onClose={onClose} open={open} dialogContentClass={dialogContentClass}>
      <FailedAction error={error} />
    </Modal>
  );
};
